import { parseJwt } from './utils';

function setJwtToken(token) {
  if (token) {
    window.localStorage.setItem('token', token);
  } else {
    window.localStorage.removeItem('token');
  }
}

function setSocketToken(token) {
  if (token) {
    const socketToken = encodeURIComponent(token);
    window.localStorage.setItem('socketToken', socketToken);
  } else {
    window.localStorage.removeItem('socketToken');
  }
}

function getSocketToken() {
  return window.localStorage.getItem('socketToken');
}

const storage = {
  getJwtToken() {
    const token = window.localStorage.getItem('token');

    if (!token) {
      return null;
    }

    if (parseJwt(token).exp < Date.now() / 1000) {
      setJwtToken(null);
      return null;
    }
    return token;
  },
  setJwtToken,
  setSocketToken,
  getSocketToken,
};

export default storage;
